import FacebookService from './FacebookService';
import 'l10nModule';

export default angular.module('edge.platform.facebook', [
    'edge.platform.l10n'
])
    .provider('FacebookService', FacebookService);